module.exports = __webpack_public_path__ + "img/step3-1.732f1577.png";